import Vue from 'vue'
import App from './App.vue'
import moment from 'moment'
import router from './router'
import ElementUI from 'element-ui'

import { i18n } from './i18n/i18n'
import I18nMixin from './i18n/i18n_mixin'

import './plugins/element.js'

Vue.use(ElementUI)

Vue.config.productionTip = false

moment.locale('ru')

new Vue({
  router,
  i18n,
  mixins: [I18nMixin],
  render: h => h(App),
  mounted () {
    const locale = this.$route.query.lang
    if (this.isLocaleSupported(locale)) {
      this.setLocale(locale)
    }
  }
}).$mount('#app')
